import { FaLinkedin, FaTwitter, FaWhatsapp, FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './Footer.css';
import { Helmet } from 'react-helmet';

const Footer = () => (
  <>
    <Helmet>{/* Open Graph and Twitter card tags */}</Helmet>
    <footer className="footer">
      <div className="footer-links-container">
        <div className="footer-branding">
          <span className="footer-logo">
            <span className="logo-main">Keep</span>
            <span className="logo-accent">MyAsset</span>
          </span>
          <span className="footer-slogan">
            One secure place for every asset your family should know about
          </span>
        </div>
        <div className="footer-links-center">
          <div className="footer-links-row">
            <Link to="/#features">Features</Link>
            <Link to="/how-it-works">How it works</Link>
            <Link to="/security">Security</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/about">About</Link>
            <Link to="/reviews">Reviews</Link>
          </div>
          <div className="footer-links-row footer-links-row-secondary">
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/about">Roadmap</Link>
            <Link to="/about">Blog</Link>
            <a href="https://wa.me/918318959079" target="_blank" rel="noopener noreferrer">Support</a>
            <a href="mailto:team.keepmyasset@gmail.com">Contact</a>
          </div>
        </div>
        <div className="footer-social-icons">
          <a
            href="https://twitter.com/keepmyasset/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon twitter"
            aria-label="Twitter"
          >
            <FaTwitter />
          </a>
          <a
            href="https://www.linkedin.com/in/keepmyassets-keepmyassets-904a86372/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon linkedin"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://wa.me/918318959079"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon whatsapp"
            aria-label="WhatsApp"
          >
            <FaWhatsapp />
          </a>
          <a
            href="https://instagram.com/keepmyassets/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon instagram"
            aria-label="Instagram"
          >
            <FaInstagram />
          </a>
        </div>
      </div>
      <div className="footer-copy">
        © {new Date().getFullYear()} KeepMyAsset. All rights reserved. Your data belongs to you.
      </div>
    </footer>
  </>
);

export default Footer;
